const easeOutQuart = (time: number) => 1 - Math.pow(1 - time, 4);
const scrollLeftProperty = 'scrollLeft';

export function scrollElementAnimated({
  element,
  moveTo,
  duration = 700,
}: {
  element: HTMLElement;
  moveTo: number;
  duration: number;
}) {
  const ease = easeOutQuart;
  const startPoint = element[scrollLeftProperty];
  let start: null | number = null;

  const step = (timestamp: number) => {
    if (start === null) {
      start = timestamp;
    }

    const time = Math.min(1, (timestamp - start) / duration);
    element[scrollLeftProperty] =
      startPoint + ease(time) * (moveTo - startPoint);

    if (time === 1) {
      start = null;
    } else {
      requestAnimationFrame(step);
    }
  };

  if (startPoint !== moveTo) {
    requestAnimationFrame(step);
  }
}
